import { ListContainer } from "@/components/layout/ListContainer";
import { InstallationQuotationItem } from "@/features/orders/installationQuotation/InstallationQuotationItem";
import { useActiveProject } from "@/features/project/ActiveProject";
import { hasItems } from "@repo/utils";

interface InstallationQuotationsProps {
  editable?: boolean;
}
export const InstallationQuotations = ({
  editable,
}: InstallationQuotationsProps) => {
  const { opportunity } = useActiveProject();

  const installationQuotations =
    opportunity?.installationQuotes?.installationQuotationInfo;

  if (!hasItems(installationQuotations)) {
    return null;
  }

  return (
    <ListContainer>
      {installationQuotations.map((installationQuotation) => (
        <InstallationQuotationItem
          key={installationQuotation.id}
          editable={editable}
          installationQuotation={installationQuotation}
        />
      ))}
    </ListContainer>
  );
};
